import React from 'react';
import './index.css';

const InvalidLinkPage = () => {
    return (
        <div className="invalid-link d-flex flex-column justify-content-center text-center">
            <img className="mx-auto my-4" src="https://www.gmailsharedcontacts.com/wp-content/uploads/2020/04/invalid-link.png" alt=""/>
            <h2 className="font-weight-light mb-4">Sorry, this invitation link is not valid</h2>
            <p>The link you've clicked is either invalid or manipulated.</p>
            <p>Please check the link and try again</p>
        </div>
    );
};

export default InvalidLinkPage;